// @ts-ignore
import("bootstrap")
